import {httpGet,httpPost,httpPostPayload} from '../../../api/base'
import config from '../../../config/config'
//接口调用的统一方法书写
export default{
	getUserInfo(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/personal/detail',params)
	},
	getCareList(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/home/cares/list',params)
	},
	getPackageInfo(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/package/info',params)
	},
	getAddress(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/address/list',params)
	},

	//birthday tips
	getBirthdayTips(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/birthday/birthdayInfo',params)
	},
	//birthday lately
	getBirthdayLately(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/birthday/birthdayInfoCount',params)
	},
	//activity list
	getActivityList(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/home/activity/list',params)
	},
	//goods info
	getGoodsInfo(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/goods/info',params)
	},
	//user address list
	getUserAddressList(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/address/list',params)
	},
	//receive real
	receiveReal(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/receive',params)
	},
	//receive Virtual
	receiveVirtual(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/receiveVirtual',params)
	},

	// change address
	orderChangeAddress(params,cb){
		return httpPost(config.default_domin+'backend/api/fe/v1/private/v3/welfare/updateOrderAddress',params)
	},
}